import Message from '../components/mail/model/Message';
import Paging from '../components/mail/model/Paging';
import { MailActionTypeKeys } from './mailActionTypes';

// Refresh List Action
export const refreshList = (messageList: Message[]) => {
  return {
    messageList,
    type: MailActionTypeKeys.REFRESH_EMAIL_LIST
  } as IRefreshMessageListAction;
}

export interface IRefreshMessageListAction {
  readonly type: MailActionTypeKeys.REFRESH_EMAIL_LIST;
  readonly messageList: Message[]
}

// Check/Uncheck Action
export const checkUncheck = (messageList: Message[]) => {
  return {
    messageList,
    type: MailActionTypeKeys.CHECK_UNCHECK_EMAILS,
  } as ICheckUncheckAction;
}

export interface ICheckUncheckAction {
  readonly type: MailActionTypeKeys.CHECK_UNCHECK_EMAILS;
  readonly messageList: Message[];
}

// Mark Message Read Action
export const markMessageRead = (messageId: string) => {
  return {
    messageId,
    type: MailActionTypeKeys.MARK_MESSAGE_READ
  } as IMarkMessageReadAction;
}

export interface IMarkMessageReadAction {
  readonly type: MailActionTypeKeys.MARK_MESSAGE_READ;
  readonly messageId: string
}

// Select Message Action
export const selectMessage = (message: Message) => {
  return {
    message,
    type: MailActionTypeKeys.SELECT_EMAIL,
  } as ISelectMessageAction;
}

export interface ISelectMessageAction {
  readonly type: MailActionTypeKeys.SELECT_EMAIL;
  readonly message: Message;
}

// Sorting Action
export const setSortFieldAndOrder = (sortField: string, isDesc: boolean) => {
  return {
    sortField,
    isDesc,
    type: MailActionTypeKeys.SET_SORT_FIELD_AND_ORDER,
  } as ISetSortFieldAndOrderAction;
}

export interface ISetSortFieldAndOrderAction {
  readonly type: MailActionTypeKeys.SET_SORT_FIELD_AND_ORDER;
  readonly sortField: string;
  readonly isDesc: boolean;
}

// Pagination Info Action
export const savePaginationInfo = (paginationInfo: Paging) => {
  return {
    paginationInfo,
    type: MailActionTypeKeys.SAVE_PAGINATION_INFO
  } as ISavePaginationInfoAction;
}

export interface ISavePaginationInfoAction {
  readonly type: MailActionTypeKeys.SAVE_PAGINATION_INFO;
  readonly paginationInfo: Paging;
}

// Mobile release edit mode
export const setReleaseEditMode = (releaseMode: boolean) => {
  return {
    releaseMode,
    type: MailActionTypeKeys.SET_RELEASE_EDIT_MODE
  } as ISetReleaseEditModeAction;
}

export interface ISetReleaseEditModeAction {
  readonly type: MailActionTypeKeys.SET_RELEASE_EDIT_MODE;
  readonly releaseMode: boolean;
}

// Mobile delete edit mode
export const setDeleteEditMode = (deleteMode: boolean) => {
  return {
    deleteMode,
    type: MailActionTypeKeys.SET_DELETE_EDIT_MODE
  } as ISetDeleteEditModeAction;
}

export interface ISetDeleteEditModeAction {
  readonly type: MailActionTypeKeys.SET_DELETE_EDIT_MODE;
  readonly deleteMode: boolean;
}

// Mobile delete edit mode
export const clearMailData = () => {
  return {
    type: MailActionTypeKeys.CLEAR_MAIL_DATA
  } as IClearMailDataAction;
}

export interface IClearMailDataAction {
  readonly type: MailActionTypeKeys.CLEAR_MAIL_DATA;
}



// WEBPACK FOOTER //
// ./src/actions/mailActions.ts